import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedOrder } from '../../../../../../selectors/tools';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';
import { OrderItemsSettingsContextProvider } from '../../Common/SearchResults/Common/DTOrderSearchResult/OrderItemsWrapper/OrderItemsSettingsContext';
import { SearchResultsSettingsContextProvider } from '../../Common/SearchResults/SearchResultsSettingsContext';
import { getDecisionNodeAtPath } from '../../../../../../extractFromState';

const DTSelectOrderNode = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector(getSelectedOrder);
  const decisionNode = useSelector(getDecisionNodeAtPath);

  const handleNextButtonClick = () => {
    dispatch(addEdgeToDecisionTreePath('order_selected'));
  };

  return (
    <OrderItemsSettingsContextProvider value={{ hideItemCheckbox: true }}>
      <CustomNoResultsComponentContextProvider value={<DTNoResultsLink />}>
        <SearchResultsSettingsContextProvider
          value={{
            useCustomLayout: !isEmpty(decisionNode?.orderCustomSettings),
            settings: decisionNode?.orderCustomSettings,
          }}
        >
          <DTOrderSearchView onNextButtonClick={handleNextButtonClick} isNextButtonActive={!isEmpty(selectedOrder)} />
        </SearchResultsSettingsContextProvider>
      </CustomNoResultsComponentContextProvider>
    </OrderItemsSettingsContextProvider>
  );
};

export default DTSelectOrderNode;
